import { createSlice } from '@reduxjs/toolkit'
import { logoutUser } from '../middlewares/logoutMiddleware'

const initialState = {
    showCreateConceptualLabelDrawer: false,
    editingConceptualLabelId: null,
    createFormInitialValues: {},
    showInactiveDisciplines: false,
    showSystemDisciplines: true,
}

const conceptualLabelSlice = createSlice({
    name: 'conceptualLabel',
    initialState,
    reducers: {
        setShowCreateConceptualLabelDrawer: (state, action) => {
            state.showCreateConceptualLabelDrawer = action.payload
            if (action.payload === false) {
                state.createFormInitialValues = {}
            }
        },
        setEditingConceptualLabelId: (state, action) => {
            state.editingConceptualLabelId = action.payload
        },
        setCreateFormInitialValues: (state, action) => {
            state.createFormInitialValues = action.payload
        },
        setShowInactiveDisciplines: (state, action) => {
            state.showInactiveDisciplines = action.payload
        },
        setShowSystemDisciplines: (state, action) => {
            state.showSystemDisciplines = action.payload
        },
        reset: () => initialState,
    },
    extraReducers: builder => builder.addCase(logoutUser, () => initialState),
})

export const conceptualLabelActions = conceptualLabelSlice.actions

export default conceptualLabelSlice.reducer
